import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { configResponsive as cr } from "@sundae/react-hooks";
import cx from "classnames";
import { Outlet } from "react-router-dom";
import GradientBackground from "../components/GradientBackground/index.js";
import Header from "../components/Header/index.js";
import InitialPageTransition from "../components/InitialPageTransition/index.js";
import { configResponsive } from "../config/responsive.js";
import { useIsInitialPageLoad } from "../hooks/useIsFirstMount.js";
const MainLayout = () => {
    cr(configResponsive);
    const { isInitialPageLoad } = useIsInitialPageLoad();
    return (_jsxs(_Fragment, { children: [_jsxs("main", { className: cx("min-h-screen overflow-hidden", "dark:bg-gray-900 dark:bg-none"), children: [_jsx(Header, {}), _jsx("article", { className: cx("mx-auto mt-[5rem] p-4 lg:mt-[5.5rem] lg:p-6", "max-w-screen-xxl min-h-screen"), children: isInitialPageLoad ? _jsx(InitialPageTransition, {}) : _jsx(Outlet, {}) })] }), !isInitialPageLoad && _jsx(GradientBackground, {})] }));
};
export default MainLayout;
//# sourceMappingURL=MainLayout.js.map